import { computed } from 'mobx';
export const cachedSet = computed({
    equals: (a, b) => [...a.filter(item => !b.includes(item)), ...b.filter(item => !a.includes(item))].length === 0,
});
/*
export const cachedSetDebug = computed({
  equals: (a: any[], b: any[]) => {
    console.log(
      'cachedSetTest',
      a.filter(item => !b.includes(item)),
      b.filter(item => !a.includes(item)),
    );
    return [...a.filter(item => !b.includes(item)), ...b.filter(item => !a.includes(item))].length === 0;
  },
});
*/
// export const sortedSet = computed.shallow;  10.11.2019 - Funktioniert NICHT, doppelte sounds!!
export const sortedSet = computed({
    equals: (a, b) => Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.reduce((isSame, current, index) => current === b[index] && isSame, true),
});
export const sortedSetDebug = computed({
    equals: (a, b) => {
        console.log('sortedSetDebug', a, b, Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.reduce((isSame, current, index) => current === b[index] && isSame, true));
        return (Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.reduce((isSame, current, index) => current === b[index] && isSame, true));
    },
});
